var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isModalOpen)?_c('div',{staticClass:"modal-common",on:{"click":_vm.clickOutside}},[_c('div',{staticClass:"modal-common-content"},[_c('span',{staticClass:"close",on:{"click":_vm.closeModal}},[_vm._v("×")]),_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }